import { useTranslation } from 'react-i18next';
import { useTemplates } from '@/hooks/useDocFlow';
import type { IOutputField } from '@/types/docflow';

interface PromptTemplateSelectorProps {
  value: string;
  onSelect: (templateId: string, fields: IOutputField[]) => void;
}

const PromptTemplateSelector: React.FC<PromptTemplateSelectorProps> = ({ value, onSelect }) => {
  const { t } = useTranslation('docflow');
  const { data: templates } = useTemplates();

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
        {t('config.template')}
      </label>
      <select
        value={value}
        onChange={(e) => {
          const template = templates?.find((tmpl) => tmpl.id === e.target.value);
          if (template) {
            onSelect(template.id, template.fields);
          }
        }}
        className="w-full text-sm px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 dark:text-gray-200"
      >
        <option value="">Select a template...</option>
        {templates?.map((tmpl) => (
          <option key={tmpl.id} value={tmpl.id}>
            {tmpl.name} — {tmpl.description}
          </option>
        ))}
      </select>
    </div>
  );
};

export default PromptTemplateSelector;
